import { Activity } from 'lucide-react';
import { SessionCreatedEvent as SessionCreatedEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: SessionCreatedEventType;
}

export default function SessionCreatedEvent({ event }: Props) {
  return (
    <EventShell
      color="blue"
      icon={<Activity className="w-3.5 h-3.5" />}
      title="Session Started"
      timestamp={event.created_at}
    >
      <p>Initiated by {event.payload.initiated_by}</p>
      {event.payload.page_url && <p className="truncate">On: {event.payload.page_url}</p>}
    </EventShell>
  );
}
